/**
 * Expands a two-digit year to four digits. Birth years cannot be in the future,
 * so a two-digit value above the current year's last two digits must be 19xx.
 */
export const expandTwoDigitYear = (
  value: string,
  currentYear = new Date().getUTCFullYear(),
): string => {
  if (!/^\d{2}$/.test(value)) {
    return value;
  }

  const twoDigits = Number(value);
  const century = twoDigits <= currentYear % 100 ? 2000 : 1900;
  return String(century + twoDigits);
};
